
import { useContext } from 'react';
import { FormControl, OutlinedInput, InputAdornment, IconButton, Button } from "@mui/material";
import { BulkContext } from '../store/bulklist-filters-context';
import SearchIcon from '@mui/icons-material/Search';
import { useFlatIndicators } from '../utils/indicatorsrList';


export default function SearchIndicator({ isMobile }) {
    const { searchQuery, setSearchQuery, setChecked, setSelectedItems } = useContext(BulkContext);
    const list = useFlatIndicators();

    const selectAllIndicators = () => {
        setChecked(list.map((item) => item.label));
        setSelectedItems(
            list.map((item) => ({
                value: item.value,
                outcome: item.outcome,
                theme: item.theme,
            }))
        );
    };


    return (
        <>
        <FormControl variant="outlined" sx={{ display: 'flex', mb: 1 }}>
            <OutlinedInput
                id="outlined-adornment-password"
                type='search'
                value={searchQuery}
                placeholder="Search indicator..."
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                sx={(theme) => ({
                    "& .MuiInputBase-input::placeholder": {
                        fontSize: "10px",
                        color: theme.palette.primary.fontColor,
                        opacity: "0.7",
                    },
                    "@media (min-width: 1200px)": {
                        "& .MuiInputBase-input::placeholder": {
                            fontSize: "12px",
                        },
                    },
                    "@media (min-width: 1366px)": {
                        "& .MuiInputBase-input::placeholder": {
                            fontSize: "13px",
                        },
                    },
                    ml: isMobile ? 1.5 : 0, mr: isMobile ? 1.5 : 0,
                })}

                onChange={(e) => setSearchQuery(e.target.value)}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label='search indicator'
                        >
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                }
            />
        </FormControl>
        <Button
            variant="outlined"
            size="small"
            fullWidth
            onClick={selectAllIndicators}
            sx={{
                textTransform: "none",
                mb: 1.5,
                ml: isMobile ? 1.5 : 0,
                mr: isMobile ? 1.5 : 0,
                width: isMobile ? "auto" : "100%",
            }}
        >
            Select all indicators
        </Button>
        </>
    )
}